import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconSkipPreviousStyle0 = cosmosIconCss;

const CosmosIconSkipPrevious$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSkipPrevious extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '15dda8341fa465638a986517064b3d6cc3c6fa11', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bcf1188a7279c92d9a4cbbf86babbd7e9ed9cb71', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'cb44ac2665cfe4be465467a8e169110fabb97fd4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4.5a.5.5 0 0 1 .5-.5H6a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-13Zm10.614 13.336-6.455-6.443a.565.565 0 0 1 0-.786l6.455-6.443a.553.553 0 0 1 .786 0l.387.387a.565.565 0 0 1 0 .786l-5.668 5.658 5.668 5.668a.565.565 0 0 1 0 .786l-.387.387a.553.553 0 0 1-.786 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconSkipPreviousStyle0; }
}, [1, "cosmos-icon-skip-previous", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-skip-previous"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-skip-previous":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSkipPrevious$1);
            }
            break;
    } });
}

const CosmosIconSkipPrevious = CosmosIconSkipPrevious$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSkipPrevious, defineCustomElement };
